import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../../PageHeader/PageHeader'
import AppButton from '../../../components/AppButton/AppButton';
import AppInput from '../../../components/AppInput/AppInput';
import { useDispatch, useSelector } from 'react-redux';
import TextArea from '../../../components/AppInput/TextArea';
import FileuploadComp from '../../../components/SingleFileUpload/FileuploadComp';
import { addParent, updateParent, searchParent } from '../../../constant/Constant';
import { ParentValidationSchema } from '../../../validationscheema/ParentValidation';
import { setApiErrorJson, setApiJson } from '../../../redux/Actions/ApiAction';
import { getSelectedUnit } from '../../../storage/Storage';
import { HitApi } from '../../../Api/ApiHit';
import toast from 'react-hot-toast';
import { getErrorMsg, hasError } from '../../../utils/utils';

function AddParent() {
    const [isEditMode, setIsEditMode] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoadingOptions, setIsLoadingOptions] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const url = window.location.pathname;
    const urlId = url.split('/')[3];

    const ApiReducer = useSelector((state) => state.ApiReducer);


    useEffect(() => {

        const initialParentData = {
            name: "",
            parentDesc: "",
            img: ""
        };

        if (urlId) {
            setIsEditMode(true);
            loadParentData();
        } else {
            dispatch(setApiJson(initialParentData));
            dispatch(setApiErrorJson({}));
        }
    }, [dispatch, urlId]);

    const loadParentData = () => {
        setIsLoadingOptions(true);

        const selectedUnit = getSelectedUnit();

        var json = {
            page: 1,
            limit: 10,
            search: {
                _id: urlId,
                unitIds: selectedUnit?._id
            }
        };


        HitApi(json, searchParent).then((res) => {
            if (res?.statusCode === 200) {
                const parentData = res?.data?.docs?.[0];
                if (parentData) {
                    dispatch(setApiJson(parentData));
                } else {
                    toast.error('No parent data found');
                }
            } else {
                toast.error('Failed to load parent data');
            }
        }).catch((error) => {
            toast.error('Error loading parent service data. Please try again.');
        }).finally(() => {
            setIsLoadingOptions(false);
        });
    };

    const handleSubmit = () => {
        setIsSubmitting(true);

        ParentValidationSchema(ApiReducer?.apiJson).then((error) => {
            dispatch(setApiErrorJson(error));

            if (Object.keys(error).length === 0) {
                const selectedUnit = getSelectedUnit();

                const parentData = {
                    ...ApiReducer.apiJson,
                    id: urlId,
                    unitIds: selectedUnit?._id
                };

                if (isEditMode) {
                    // Update existing parent
                    HitApi(parentData, updateParent).then((res) => {

                        if (res?.statusCode === 200) {
                            toast.success('Parent service updated successfully!');
                            setTimeout(() => {
                                navigate('/services');
                            }, 1000);
                        } else {
                            toast.error('Failed to update parent service. Please try again.');
                        }
                    }).catch((error) => {
                        toast.error('Error updating parent service. Please try again.');
                    }).finally(() => {
                        setIsSubmitting(false);
                    });
                } else {
                    // Add new parent
                    let json = {
                        ...ApiReducer.apiJson,
                        unitIds: selectedUnit?._id
                    }

                    HitApi(json, addParent).then((res) => {

                        if (res?.statusCode === 201) {
                            toast.success('Parent service added successfully!');
                            setTimeout(() => {
                                navigate('/services');
                            }, 1000);
                        } else {
                        }
                    }).catch((error) => {
                    }).finally(() => {
                        setIsSubmitting(false);
                    });
                }
            } else {
                setIsSubmitting(false);
            }
        }).catch((validationError) => {
            setIsSubmitting(false);
        });
    }


    return (
        <div className='p-5'>
            <PageHeader
                title={isEditMode ? 'Update Group' : 'Add New Group'}
                description={isEditMode ? 'Update service group information' : 'Create a new service group'}
            />

            <div className="bg-white p-8 border rounded-xl mb-6">
                <div className="text-lg font-medium mb-5 flex justify-between items-center">
                    <span>Group Information</span>
                </div>

                <div className="grid grid-cols-1 gap-4 mb-6">
                    <AppInput
                        title="Service Name"
                        placeholder="Enter service name"
                        name="name"
                        error={hasError('name', ApiReducer)}
                        errormsg={getErrorMsg('name', ApiReducer)}
                        important={true}
                        str
                    />
                    <TextArea
                        title="Description"
                        name="parentDesc"
                        placeholder="Describe the service benefits and details..."
                        rows={3}
                    />
                    <div className='mb-5'>
                        <FileuploadComp title="Image URL" name="img" allowed={["img"]} />
                    </div>
                </div>
                <div className='flex justify-end mt-5'>
                    <AppButton
                        buttontext={isSubmitting ? "Processing..." : (isEditMode ? "Update Group" : "Add Group")}
                        onClick={handleSubmit}
                        disabled={isSubmitting || isLoadingOptions}
                        isLoading={isSubmitting}
                    />
                </div>
            </div>
        </div>
    )
}

export default AddParent